import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useData, useStatus, isLoading, combineStatuses } from 'resift';
import makeGetRoleMembers from 'fetches/rolesAndPermissions/makeGetRoleMembers';
import makeGetRole from 'fetches/rolesAndPermissions/makeGetRole';
import makeGetUserFieldsFetch from 'fetches/makeGetUserFieldsFetch';
import CircularProgress from '@material-ui/core/CircularProgress';
import ManageRoleMembersPage from './ManageRoleMembersPage';

function Container() {
  const dispatch = useDispatch();
  const getUserFields = makeGetUserFieldsFetch();
  const userFields = useData(getUserFields);
  const getUserFieldsStatus = useStatus(getUserFields);
  const { roleId } = useParams<{ roleId: string }>();
  const getRole = makeGetRole(roleId);
  const getRoleMembers = makeGetRoleMembers(roleId);

  const roleMembersResponse = useData(getRoleMembers);
  const getRoleMembersStatus = useStatus(getRoleMembers);

  const role = useData(getRole);
  const getRoleStatus = useStatus(getRole);

  const status = combineStatuses(getRoleMembersStatus, getRoleStatus, getUserFieldsStatus);

  useEffect(() => {
    dispatch(getRoleMembers());

    if (!role) {
      dispatch(getRole());
    }
  }, [dispatch, getRoleMembers, getRole, role]);

  useEffect(() => {
    if (!userFields) {
      dispatch(getUserFields());
    }
  }, []);

  if (isLoading(status)) {
    return <CircularProgress color="secondary" />;
  }

  return <ManageRoleMembersPage roleMembersResponse={roleMembersResponse} role={role} />;
}

export default Container;
